module.exports = __webpack_public_path__ + "img/samplea.67d9320c.png";